const getApiBaseUrl = () => {
  return import.meta.env.VITE_API_BASE_URL || 'https://api.canadawaleyar.com';
};

export const API_BASE_URL = getApiBaseUrl();

/** @deprecated iframe removed — use native booking wizard at /appointments/:slug/book */
export const BOOKING_BASE_URL =
  import.meta.env.VITE_BOOKING_BASE_URL || 'https://appointment.canadawaleyar.com';

export const CONSULTATION_SERVICE_ID =
  import.meta.env.VITE_CONSULTATION_SERVICE_ID ?? '68390d1eb608e96c269aa229';

export const DEFAULT_APPOINTMENT_SLUG =
  import.meta.env.VITE_DEFAULT_APPOINTMENT_SLUG ?? 'kevin';

export const CANADA_APPOINTMENT_SLUG = 'kevin';
export const INDIA_APPOINTMENT_SLUG = 'rudra';

export type AppointmentCountry = 'CA' | 'IN';

export function getDefaultAppointmentSlug(country: AppointmentCountry = 'CA'): string {
  if (import.meta.env.VITE_DEFAULT_APPOINTMENT_SLUG) {
    return import.meta.env.VITE_DEFAULT_APPOINTMENT_SLUG;
  }
  return country === 'IN' ? INDIA_APPOINTMENT_SLUG : CANADA_APPOINTMENT_SLUG;
}

export function appointmentBookingPathForCountry(country: AppointmentCountry = 'CA'): string {
  return `/appointments/${getDefaultAppointmentSlug(country)}/book`;
}

/** @deprecated use appointmentBookingPathForCountry(country) */
export const defaultAppointmentBookingPath = () =>
  appointmentBookingPathForCountry('CA');

export const API_ENDPOINTS = {
  HEALTH: `${API_BASE_URL}/health`,

  // Products / Store
  PRODUCTS_PUBLIC: `${API_BASE_URL}/api/products/public`,
  ESIM_CANADA: `${API_BASE_URL}/api/esim/canada`,
  ESIM_INDIA: `${API_BASE_URL}/api/esim/india`,
  ESIM_CHECKOUT: `${API_BASE_URL}/api/esim/checkout`,
  ESIM_CHECKOUT_ABANDON: `${API_BASE_URL}/api/esim/checkout/abandon`,
  ESIM_CHECKOUT_FAILED: `${API_BASE_URL}/api/esim/checkout/failed`,
  ESIM_VERIFY: `${API_BASE_URL}/api/esim/verify`,
  ESIM_ORDER: (saleId: string) => `${API_BASE_URL}/api/esim/orders/${saleId}`,
  ESIM_ORDERS: `${API_BASE_URL}/api/esim/orders`,
  PRODUCT_BY_SLUG: (slug: string) => `${API_BASE_URL}/api/products/public/${slug}`,
  PRODUCT_CHECKOUT: `${API_BASE_URL}/api/products/public/checkout`,
  PRODUCT_CONFIRM: `${API_BASE_URL}/api/products/public/confirm`,

  // Vehicle listings (dealer car inventory)
  CAR_INVENTORY_PUBLIC: `${API_BASE_URL}/api/public/car-inventory`,
  CAR_INVENTORY_BY_ID: (vehicleId: string) =>
    `${API_BASE_URL}/api/public/car-inventory/${encodeURIComponent(vehicleId)}`,

  // App content (home + consultants by country)
  APP_CONTENT_HOME: `${API_BASE_URL}/api/app-content/home`,
  APP_CONTENT_CONSULTANTS: `${API_BASE_URL}/api/app-content/consultants`,

  // Appointment takers
  APPOINTMENT_TAKERS: `${API_BASE_URL}/api/appointment/takers/booking`,
  APPOINTMENT_TAKER_BY_SLUG: (slug: string) =>
    `${API_BASE_URL}/api/appointment/takers/slug/${slug}`,

  // Booking slots & availability
  SLOTS: `${API_BASE_URL}/api/appointment/slots`,
  CREATE_BOOKING: `${API_BASE_URL}/api/appointment/create`,
  AVAILABILITY: `${API_BASE_URL}/api/availability`,

  // Coupons
  COUPON_VALIDATE: `${API_BASE_URL}/api/coupons/validate`,
  COUPON_APPLY: `${API_BASE_URL}/api/coupons/apply`,

  // Stripe (shared by booking and store)
  STRIPE_CHECKOUT: `${API_BASE_URL}/api/stripe/request`,
  STRIPE_STATUS: (sessionId: string) => `${API_BASE_URL}/api/stripe/status/${sessionId}`,
};
